export default __webpack_public_path__ + "static/media/3.ffb2c0d2.svg";